import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CircularProgress from '@mui/material/CircularProgress';
import { useAppContext } from '../AppContext';
import {axios_tenant} from '../../../../axios';
import { toast } from 'react-toastify';

function DeleteItem({ selectedItem, handleCloseContextMenu, showSnackbar, fetchFolderContents,setActionStatus }) {
  const appData = useAppContext();
  const [isDeleting, setDeleting] = useState(false);

  const handleDeleteClick = async () => {
    try {
      setDeleting(true);
      setActionStatus(true);

      // Choose the appropriate endpoint based on the item type
      const deleteEndpoint = `/collaboration/deleteItem/${selectedItem.type}/${selectedItem.type === 'folder' ? selectedItem.folderId : selectedItem.fileId}`;

      // Show a confirmation dialog before proceeding with deletion
      const isConfirmed = window.confirm(`Are you sure you want to delete ${selectedItem.type === 'file' ? 'file' : 'folder'} "${selectedItem.type === 'file' ? `${selectedItem.fileName}` : `${selectedItem.folderName}`}" ?`);

      if (isConfirmed) {
        // Trigger the delete request
        await axios_tenant.delete(deleteEndpoint);

        // Update the UI or handle success as needed

        // Show success snackbar
        toast.success("Item deleted successfully");
        // showSnackbar('Item deleted successfully');
        fetchFolderContents();
      }
    } catch (error) {
      setActionStatus(false);
      // Show error snackbar
      // showSnackbar('Error deleting item', true);
      // toast.error("Error deleting item");
    } finally {
      setActionStatus(false);
      setDeleting(false);
      handleCloseContextMenu();
    }
  };

  return (
    <>
      <MenuItem onClick={handleDeleteClick}>
      {isDeleting ? (
          <CircularProgress size={20} style={{ marginRight: 8 }} />
        ) : (
          <DeleteOutlineIcon fontSize="small" style={{ marginRight: 8 }} />
        )}
        <span>Delete</span>
      </MenuItem>      
    </>
  );
}

export default DeleteItem;
